import { addDoc, collection, doc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { message } from "antd";
import dayjs from "dayjs";
import toast from "react-hot-toast";

export const createNewServiceRequest = async (
  data,
  companyName,
  propertyId,
  createdBy,
  unitTurnId,
  unitTurnCategory,
  isUnitTurn
) => {
  const companiesRef = collection(db, "companies");
  const companyDocRef = doc(companiesRef, companyName);
  const newServiceRequestRef = collection(companyDocRef, "workOrders");

  const unit = data?.unit || null;
  const randomNum = Math.floor(Math.random() * (9 - 1 + 1)) + 1;
  const today = new dayjs();
  console.log("randomNum , today", createdBy);

  Object.keys(data).forEach((field) => {
    if (data[field] === undefined) {
      data[field] = "";
    }
  });

  try {
    await addDoc(newServiceRequestRef, {
      ownerInformation: {
        propertyId: isUnitTurn ? propertyId : data.property,
        unit: isUnitTurn ? propertyId : unit,
        workOrderType: isUnitTurn ? "Unit Turns" : data.workOrderType,
        permissionToEnter: data.permission || "",
        additionalInfo: data.additionalInfo || "",
        priority: data.priority || "",
        description: data.description || "",
        useServiceRequestDescAsJobDesc: data.useServiceRequest
          ? data.useServiceRequest
          : false,
      },

      workOrderInformation: {
        createdBy: createdBy ? createdBy : "",
        reqNumber: randomNum,
        creationData: today.format("YYYY-MM-DD"),
        ownerApproved: data.ownerApproved ? data.ownerApproved : false,
        jobDescription: data.jobDescription || "",
        vendorInstructions: data.vendorInstruction || "",
        vendorTrade: data.vendorTrade || "",
        vendorId: data.vendor || "",
        emailVendor: data.emailVendor ? data.emailVendor : false,
        textVendor: data.textVendor ? data.textVendor : false,
        requestVendor: data.requestVendor || "",
        assignTo: data.assignTo || null,
        followUpDate: data["followUpDate"]
          ? data["followUpDate"].format("DD-MM-YYYY")
          : "" || "",
      },

      unit_turn_id: isUnitTurn ? unitTurnId : null,
      unit_turn_category: isUnitTurn ? unitTurnCategory : null,
      status:"pending"
    });
    toast.success("New Service Request created successfully!");
  } catch (error) {
    toast.error("Error in creating new Service Request..........:", error);
    console.log("error", error)
  }
};
